/**
 * Shared span implementation using the browser Performance API.
 *
 * The orchestrator calls these directly so that every span produces a
 * `performance.measure()` entry visible in DevTools and auto-harvested
 * by NR when `capture_measures` is enabled.
 */

export function startSpan(name, attrs = {}) {
  const markName = `inst:${name}:${performance.now()}`;
  performance.mark(markName);
  return { name, markName, attrs };
}

export function endSpan(span, error) {
  if (!span) return;
  const measureName = error ? `${span.name} [error]` : span.name;
  try {
    performance.measure(measureName, { start: span.markName, detail: span.attrs });
  } catch (_) {
    // mark may have been cleared
  }
}

export async function withSpan(name, fn, attrs = {}) {
  const span = startSpan(name, attrs);
  try {
    const result = await fn();
    endSpan(span);
    return result;
  } catch (e) {
    endSpan(span, e);
    throw e;
  }
}
